import axios from 'axios';
import { API, authHeader } from '@/components/library/libraryMeta';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Uploads in small chunks so large files pass the ingress body limit; each chunk retries on network/5xx errors.
export async function uploadChunked(file, meta, onProgress) {
  const init = await axios.post(`${API}/library/uploads`, {
    filename: file.name, size: file.size, content_type: file.type, ...meta,
  }, authHeader());
  const { id, chunk_size: size, total_chunks: total } = init.data;
  for (let i = 0; i < total; i += 1) {
    const blob = file.slice(i * size, Math.min(file.size, (i + 1) * size));
    for (let attempt = 1; ; attempt += 1) {
      try {
        await axios.put(`${API}/library/uploads/${id}/chunks/${i}`, blob, {
          headers: { ...authHeader().headers, 'Content-Type': 'application/octet-stream' },
          onUploadProgress: (e) => onProgress(Math.min(0.99, (i * size + (e.loaded || 0)) / file.size)),
        });
        break;
      } catch (err) {
        if (attempt >= 3 || err.response?.status < 500) throw err;
        await sleep(800 * attempt);
      }
    }
  }
  const done = await axios.post(`${API}/library/uploads/${id}/complete`, {}, authHeader());
  onProgress(1);
  return done.data.item;
}
